import { render, staticRenderFns } from "./EnquiryPaste.vue?vue&type=template&id=5c518074&"
import script from "./EnquiryPaste.vue?vue&type=script&lang=js&"
export * from "./EnquiryPaste.vue?vue&type=script&lang=js&"
import style0 from "./EnquiryPaste.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports